// Helper function to get CSRF token from meta tag
const getCSRFToken = () => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  if (!token) {
    console.warn('CSRF token not found in page metadata');
  }
  return token;
};

// Default headers for all requests
const getDefaultHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  const token = getCSRFToken();
  if (token) {
    headers['X-CSRF-Token'] = token;
  }

  return headers;
};

// Handle API response
const handleResponse = async (response) => {
  if (!response.ok) {
    // Try to parse error message from response
    try {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    } catch (e) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }

  // Return null for 204 No Content
  if (response.status === 204) {
    return null;
  }

  // Parse JSON response
  try {
    return await response.json();
  } catch (e) {
    console.error('Error parsing JSON response:', e);
    throw new Error('Invalid JSON response from server');
  }
};

// API client methods
const apiClient = {
  async get(url) {
    const response = await fetch(url, {
      credentials: 'same-origin', // Include cookies in the request
      headers: getDefaultHeaders()
    });
    return handleResponse(response);
  },

  async post(url, data) {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin', // Include cookies in the request
      headers: getDefaultHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  async patch(url, data) {
    const response = await fetch(url, {
      method: 'PATCH',
      credentials: 'same-origin', // Include cookies in the request
      headers: getDefaultHeaders(),
      body: JSON.stringify(data)
    });
    return handleResponse(response);
  },

  async delete(url) {
    const response = await fetch(url, {
      method: 'DELETE',
      credentials: 'same-origin', // Include cookies in the request
      headers: getDefaultHeaders()
    });
    return handleResponse(response);
  }
};

export default apiClient; 